import axios from 'axios'
import global from '@/global/variable.js'

// 获取消息推送列表
export function getList(data) {
  const url = global.requestUrl + '/portConfig/list'
  return axios.get(url)
}

// 更新工程配置信息
export function updateOne(data) {
  const url = global.requestUrl + '/portConfig/update'
  return axios.post(url, data)
}

